<template>
  <div style="margin-top:30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="实际承运人"
              prop="driverName"
              style="margin-right:15px"
            >
              <el-input v-model="form.driverName" @focus="showSelectDriverFunc">
                <el-button
                  slot="append"
                  icon="el-icon-plus"
                  @click="showSelectDriverFunc"
                />
              </el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button type="primary" @click="funcSubmit">
        确 定
      </el-button>
    </div>
    <vxe-modal
      v-model="selectDriverFlag"
      title="选择实际承运人"
      width="800"
      height="auto"
      resize
      remember
    >
      <SelectDriver
        ref="selectDriverRef"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      />
    </vxe-modal>
  </div>
</template>
<script>
import request from "@/utils/request";
import SelectDriver from "../SelectOne.vue";

export default {
  components: {
    SelectDriver
  },
  data() {
    return {
      selectDriverFlag: false,
      pageType: "sendOrder",
      form: {
        driverName: ""
      },
      rules: {
        driverName: [
          { required: true, message: "请选择实际承运人", trigger: "change" }
        ]
      },
      branchCodeExt: ""
    };
  },
  created() {},
  methods: {
    init(entity) {
      this.form.code = entity.code;
      this.form.driverApplyRemark = entity.driverApplyRemark;
      this.branchCodeExt = entity.branchCodeOrder;
    },
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          const data = this.form;
          request({
            url: "ntocc-tms-api/orderDetail/selectDriverReceive",
            method: "POST",
            params: data
          })
            .then(response => {
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherSubmitMethod", this.pageType);
              rLoading.close();
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", this.pageType);
      this.form.driverCode = "";
      this.form.driverName = "";
    },
    showSelectDriverFunc() {
      this.selectDriverFlag = true;
      this.$refs.selectDriverRef.init({
        url: "/driver/teamDriverList",
        isTeamSendDetail: 1,
        branchCodeOrder: this.branchCodeExt
      });
    },
    fatherSubmitFunc(row) {
      this.form.driverCode = row.driverCode;
      this.form.driverName = row.name;
      this.form.vehicleCode = row.vehicleCode;
      this.selectDriverFlag = false;
    },
    fatherCancelFunc() {
      this.selectDriverFlag = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
